import { render, staticRenderFns } from "./SaleClose.vue?vue&type=template&id=2a0f96ad&scoped=true&"
import script from "./SaleClose.vue?vue&type=script&lang=js&"
export * from "./SaleClose.vue?vue&type=script&lang=js&"
import style0 from "./SaleClose.vue?vue&type=style&index=0&id=2a0f96ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f96ad",
  null
  
)

export default component.exports